import { SBRM, SBRMForm } from '@supplement-bacon/sbrm-react'
import { forwardRef } from 'react'
import { useAppDispatch, useAppSelector } from '../../../../store/hooks'
import {
  createFormQuestion,
  deleteFormQuestion,
  updateFormQuestion,
} from '../../../../store/membership/FormQuestionReducer'
import Create from './Create'
import Delete from './Delete'
import Update from './Update'

export const FormQuestionForm: SBRMForm = forwardRef(({ formProps }, ref) => {
  const dispatch = useAppDispatch()
  const { error } = useAppSelector((state) => state.formQuestion)

  return (
    <SBRM.BaseEntityForm
      {...{ ref, formProps }}
      error={error && String(error)}
      formActions={{
        create: Create,
        update: Update,
        delete: Delete,
      }}
      handlers={{
        create: async (values) =>
          dispatch(createFormQuestion(values)).then(() => {
            return true
          }),
        update: async (values) =>
          dispatch(updateFormQuestion(values)).then(() => {
            return true
          }),
        delete: async (values) =>
          dispatch(deleteFormQuestion(values)).then(() => {
            return true
          }),
      }}
    />
  )
})

FormQuestionForm.displayName = 'FormQuestionForm'

export default FormQuestionForm
